import {
  NOTIFICATION_VARIANT_ERROR,
  NOTIFICATION_VARIANT_INFO,
  NOTIFICATION_VARIANT_SUCCESS,
  NOTIFICATION_VARIANT_WARNING,
} from './notification.type';

const getContainerClasses = (type: string, neutralBg: boolean) => {
  return [
    'max-w-sm w-full shadow-md rounded-md pointer-events-auto ring-0 overflow-hidden relative',
    type === NOTIFICATION_VARIANT_ERROR && !neutralBg && 'bg-critical text-critical',
    type === NOTIFICATION_VARIANT_SUCCESS && !neutralBg && 'bg-success text-success',
    type === NOTIFICATION_VARIANT_WARNING && !neutralBg && 'bg-warning text-warning',
    type === NOTIFICATION_VARIANT_INFO && !neutralBg && 'bg-inverse text-negative',
    neutralBg && 'bg-primary text-secondary',
  ]
    .filter(Boolean)
    .join(' ');
};

const getProgressClasses = (type: string, neutralBg: boolean) => {
  return [
    'absolute bottom-0 left-0 h-1 transition-width',
    type === NOTIFICATION_VARIANT_ERROR && 'bg-critical-inverted',
    type === NOTIFICATION_VARIANT_SUCCESS && 'bg-success-inverted',
    type === NOTIFICATION_VARIANT_WARNING && 'bg-warning-inverted',
    type === NOTIFICATION_VARIANT_INFO && !neutralBg && 'bg-primary',
    type === NOTIFICATION_VARIANT_INFO && neutralBg && 'bg-inverse',
  ]
    .filter(Boolean)
    .join(' ');
};

const getButtonClasses = (type: string, neutralBg: boolean) => {
  return [
    'inline-flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 pl-4 border-l',
    type === NOTIFICATION_VARIANT_ERROR && !neutralBg && 'border-critical-soft',
    type === NOTIFICATION_VARIANT_SUCCESS && !neutralBg && 'border-sucess-soft',
    type === NOTIFICATION_VARIANT_WARNING && !neutralBg && 'border-warning-soft',
  ]
    .filter(Boolean)
    .join(' ');
};

const getIconClasses = (type: string) => {
  return [
    'h-6 w-6',
    type === NOTIFICATION_VARIANT_SUCCESS && 'text-success',
    type === NOTIFICATION_VARIANT_WARNING && 'text-warning',
    type === NOTIFICATION_VARIANT_ERROR && 'text-critical',
  ]
    .filter(Boolean)
    .join(' ');
};

export const getNotificationClasses = (type: string, neutralBg: boolean) => {
  const containerClasses = getContainerClasses(type, neutralBg);
  const progressClasses = getProgressClasses(type, neutralBg);
  const buttonClasses = getButtonClasses(type, neutralBg);
  const iconClasses = getIconClasses(type);
  const textContainerClasses = 'ml-3 w-0 flex-1 pt-0.5 pr-4 break-words hyphens-auto';

  return {
    containerClasses,
    progressClasses,
    buttonClasses,
    iconClasses,
    textContainerClasses,
  };
};
